import { gql } from "lib/apolloClient";

export const feedListFragment = {
  userFeedItems: gql`
    fragment userFeedItems on User {
      id
      firstName
      middleName
      lastName
      type
      profileImage

      ... on Student {
        preferredName
        pronouns
        prefix
        suffix
        isArchived
        yearGroup {
          id
          grade {
            id
            name
          }
        }
        courses {
          id
          title
          isArchived
        }
      }

      ... on Staff {
        isArchived
        displayRole
        preferredName
        pronouns
        prefix
        suffix
        courses {
          id
          title
          isArchived
          grades {
            id
            name
          }
        }
      }

      ... on FamilyMember {
        preferredName
        pronouns
        prefix
        suffix
        children(organizationId: $organizationId) {
          id
          firstName
          middleName
          lastName
          profileImage
          isArchived
          preferredName
          pronouns
          prefix
          suffix
        }
      }
    }
  `,
};
